import script from "./Toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./Toggle.vue?vue&type=script&setup=true&lang=ts"

import "./Toggle.vue?vue&type=style&index=0&id=43cf95d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43cf95d0"]])

export default __exports__